const o=o=>!!o,i=(i="lang")=>()=>{var l;return[null===(l=null===window||void 0===window?void 0:window.localStorage)||void 0===l?void 0:l.getItem(i)].filter(o)},l=i();export{i as initLocalStorageDetector,l as localStorageDetector};
